import { io } from "socket.io-client";

// Vacío por defecto: el socket se conecta al mismo host desde el que se
// sirve la web (ver nginx.conf, que reenvía /socket.io/ al backend).
const API_URL = import.meta.env.VITE_API_URL || "";

export function connectOperatorMatrix(token) {
  return io(`${API_URL}/matrix`, {
    auth: { token },
    transports: ["websocket", "polling"],
  });
}

export function connectPublicMatrix() {
  return io(`${API_URL}/public-matrix`, {
    transports: ["websocket", "polling"],
  });
}
